// KWANKGM04250_借入申込希望書兼経営改善資金計画書 完了のフッタボタン
import React, { memo } from 'react';
import RowCenterButton from '../molecules/RowCenterButton';
import DefaultButton from '../molecules/DefaultButton';
import { modernization_funds_complete_disp_type } from '../Const';
interface Props {
  reception_cd: string;
  reception_id: number;
  status?: number;
  disp_type: string | null;
}

const FooterBusinessImprovementFinancingPlan: React.FC<Props> = ({
  reception_cd,
  reception_id,
  status,
  disp_type,
}) => {
  // 近代化資金借入申込入力 画面へ遷移する
  const handleClickNextButton = () => {
    const url = new URL(
      `${location.origin}${process.env.MIX_MOCK_URL}/reception/${reception_cd}/${reception_id}/${status}`
    );
    url.searchParams.append('item_id', '33');
    sessionStorage.setItem('from_to_completeed', 'true');
    // 遷移元の商品IDを設定
    sessionStorage.setItem('from_to_item_id', '32');
    // 表示パターンを設定
    sessionStorage.setItem('disp_type', String(disp_type));
    window.location.href = url.href;
  };

  // 続けて借入申込書を入力ボタンのJSXをセットする
  const setNextButton = () => {
    // パターン1・借入申込変更・パターン２で借入申込書入力完了済みの場合は非表示
    if (
      disp_type === modernization_funds_complete_disp_type.pattern_1 ||
      disp_type === modernization_funds_complete_disp_type.change_borrowing_application ||
      disp_type === modernization_funds_complete_disp_type.pattern_4
    ) {
      return <></>;
    } else {
      return (
        <div className="mt-5">
          <RowCenterButton>
            <DefaultButton
              label="続けて借入申込書を入力"
              strong={false}
              handleClick={handleClickNextButton}
            />
          </RowCenterButton>
        </div>
      );
    }
  };

  return <>{setNextButton()}</>;
};

export default memo(FooterBusinessImprovementFinancingPlan);
